export enum CountryCode {
  DE = 'DE',
  AT = 'AT',
  BE = 'BE',
  CA = 'CA',
  CN = 'CN',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  GR = 'GR',
  IT = 'IT',
  JP = 'JP',
  LU = 'LU',
  NL = 'NL',
  PL = 'PL',
  PT = 'PT',
  CZ = 'CZ',
  GB = 'GB',
  SE = 'SE',
  CH = 'CH',
  DK = 'DK',
  US = 'US',
  HK = 'HK',
  NO = 'NO',
  AU = 'AU',
  SG = 'SG',
  IE = 'IE',
  NZ = 'NZ',
  KR = 'KR',
  IL = 'IL',
  ZA = 'ZA',
  NG = 'NG',
  CI = 'CI',
  TG = 'TG',
  BO = 'BO',
  MU = 'MU',
  RO = 'RO',
  SK = 'SK',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BW = 'BW',
  BR = 'BR',
  BN = 'BN',
  BF = 'BF',
  MM = 'MM',
  BI = 'BI',
  KH = 'KH',
  CM = 'CM',
  CV = 'CV',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CO = 'CO',
  KM = 'KM',
  CD = 'CD',
  CG = 'CG',
  CR = 'CR',
  HR = 'HR',
  CU = 'CU',
  CY = 'CY',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  TL = 'TL',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  GH = 'GH',
  GD = 'GD',
  GL = 'GL',
  GI = 'GI',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IM = 'IM',
  JM = 'JM',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  MO = 'MO',
  MK = 'MK',
  MG = 'MG',
  MW = 'MW',
  MY = 'MY',
  MV = 'MV',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  HU = 'HU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  AN = 'AN',
  NC = 'NC',
  NI = 'NI',
  NE = 'NE',
  NU = 'NU',
  NF = 'NF',
  MP = 'MP',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RU = 'RU',
  RW = 'RW',
  BL = 'BL',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  GS = 'GS',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TH = 'TH',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
  AL = 'AL',
  AF = 'AF',
  AQ = 'AQ',
  BA = 'BA',
  BV = 'BV',
  IO = 'IO',
  BG = 'BG',
  KY = 'KY',
  CX = 'CX',
  CC = 'CC',
  CK = 'CK',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  AX = 'AX',
  None = 'None',
}

// TODO localization
export const COUNTRY_CODE_OPTIONS = [
  { key: CountryCode.DE, value: CountryCode.DE },
  { key: CountryCode.GB, value: CountryCode.GB },
];
